import { render, staticRenderFns } from "./BasicDataAnalysis.vue?vue&type=template&id=4498aeef&scoped=true&"
import script from "./BasicDataAnalysis.vue?vue&type=script&lang=js&"
export * from "./BasicDataAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./BasicDataAnalysis.vue?vue&type=style&index=0&id=4498aeef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4498aeef",
  null
  
)

export default component.exports